import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction, httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import Vue from 'vue';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import MapGetPoint from '@/components/Map/MapGetPoint';
export default {
  name: 'TenantModal',
  components: {
    MapGetPoint: MapGetPoint
  },
  data: function data() {
    return {
      title: '租户表表单',
      tableName: 'sys_tenant',
      disableSubmit: true,
      confirmLoading: false,
      uploadLoading: false,
      uploadLoadingOne: false,
      picUrl: '',
      picUrlOne: '',
      headers: {},
      model: {},
      mapCenter: [],
      networkStatus: true,
      //网络状态
      form_fields: ['code', 'name', 'phone', 'addr', 'projectName', 'zoomLevel', 'copyright', 'mapCenter', 'homeUrl'],
      form: this.$form.createForm(this),
      validatorRules: {
        projectName: {
          rules: [{
            required: true,
            message: '请输入系统名称!'
          }]
        },
        copyright: {
          rules: [{
            required: true,
            message: '请输入技术支持!'
          }]
        },
        mapCenter: {
          rules: [{
            required: true,
            message: '请选择中心坐标!'
          }]
        }
      },
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 4
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      url: {
        tenant: '/sys/tenant/',
        edit: '/sys/tenant/',
        fileUpload: window._CONFIG['domianURL'] + '/sys/common/file/upload',
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view'
      }
    };
  },
  props: ['pagePath'],
  created: function created() {
    var token = Vue.ls.get(ACCESS_TOKEN);
    this.headers = {
      'X-Access-Token': token
    };
    this.loadTenat(this.$store.getters.userInfo.tenantId);
  },
  computed: {
    uploadAction: function uploadAction() {
      return this.url.fileUpload;
    }
  },
  methods: {
    loadTenat: function loadTenat(s) {
      var _this = this;

      this.picUrl = '';
      this.picUrlOne = '';
      getAction(this.url.tenant + s).then(function (res) {
        if (res.success) {
          _this.form.resetFields();

          _this.model = Object.assign({}, res.result);

          if (_this.model.topLogo) {
            _this.picUrl = 'Has no pic url yet';
          }

          if (_this.model.homeLogo) {
            _this.picUrlOne = 'Has no pic url yet';
          }

          _this.mapCenter = _this.model.mapCenter == undefined ? [] : _this.model.mapCenter.split(',');

          _this.$nextTick(function () {
            var that = _this; //debugger

            that.form.setFieldsValue(pick(that.model, that.form_fields));
          });
        }
      });
    },
    longitudeChange: function longitudeChange() {
      this.$refs.mapForm.show(this.mapCenter);
    },
    coordinateOk: function coordinateOk(value) {
      if (value != null) {
        this.mapCenter = value;
        this.form.setFieldsValue({
          mapCenter: value.toString()
        });
      }
    },
    beforeUpload: function beforeUpload(file) {
      var fileType = file.type;

      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        return false;
      } //TODO 验证文件大小

    },
    handleChange: function handleChange(info) {
      this.picUrl = '';

      if (info.file.status === 'uploading') {
        this.uploadLoading = true;
        return;
      }

      if (info.file.status === 'done') {
        var response = info.file.response;
        this.uploadLoading = false;

        if (response.success) {
          this.model.topLogo = response.result.id;
          this.picUrl = 'Has no pic url yet';
        } else {
          this.$notification.warning({
            message: response.message
          });
        }
      }
    },
    handleChangeOne: function handleChangeOne(info) {
      this.picUrlOne = '';

      if (info.file.status === 'uploading') {
        this.uploadLoadingOne = true;
        return;
      }

      if (info.file.status === 'done') {
        var response = info.file.response;
        this.uploadLoadingOne = false;

        if (response.success) {
          this.model.homeLogo = response.result.id;
          this.picUrlOne = 'Has no pic url yet';
        } else {
          this.$notification.warning({
            message: response.message
          });
        }
      }
    },
    getAvatarView: function getAvatarView() {
      return this.url.imgerver + '/' + this.model.topLogo;
    },
    getAvatarViewOne: function getAvatarViewOne() {
      return this.url.imgerver + '/' + this.model.homeLogo;
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //debugger
          //console.log(formData)

          var httpurl = _this2.url.edit;
          var method = 'put';
          httpAction(_this2.url.edit, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    }
  },
  // 检测断网
  mounted: function mounted() {
    var _this3 = this;

    window.addEventListener('offline', function () {
      _this3.$notification_custom({
        message: '网络异常',
        type: 'error',
        duration: 0
      });

      _this3.networkStatus = false;
    });
    window.addEventListener('online', function () {
      _this3.$notification_custom({
        message: '网络已连接',
        type: 'success',
        duration: 0
      });

      _this3.networkStatus = true;
    });
  }
};